import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { getAggregateSaleCount, getProdCmSaleVlBar } from '@/service/sale/productAndSale';
export default function useMortarSaleTrend(params) {
  var aggregateSaleTrendData = ref({
    sale: [],
    prod: [],
    xAxis: [],
    stock: []
  });
  var aggregateSaleTrendYearData = ref({
    sale: [],
    prod: [],
    xAxis: [],
    stock: []
  });
  // 获取主机汇总数据
  var getProdCmSaleVlBarAsync = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var num, type, data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            num = 30;
            type = 0;
            _context.t0 = params.value.type;
            _context.next = _context.t0 === 0 ? 5 : _context.t0 === 1 ? 8 : _context.t0 === 2 ? 11 : _context.t0 === 3 ? 14 : _context.t0 === 4 ? 17 : 20;
            break;
          case 5:
            num = 30;
            type = 0;
            return _context.abrupt("break", 20);
          case 8:
            num = 30;
            type = 1;
            return _context.abrupt("break", 20);
          case 11:
            num = 12;
            // num = 30
            type = 2;
            return _context.abrupt("break", 20);
          case 14:
            num = 3;
            // num = 12
            type = 3;
            return _context.abrupt("break", 20);
          case 17:
            num = 10;
            type = 4;
            return _context.abrupt("break", 20);
          case 20:
            console.log('num=>', num);
            _context.next = 23;
            return getProdCmSaleVlBar({
              date: params.value.date,
              type: type
              // rangeType: type,
              // rangeNum: num
            });
          case 23:
            data = _context.sent;
            aggregateSaleTrendData.value = data;
          case 25:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getProdCmSaleVlBarAsync() {
      return _ref.apply(this, arguments);
    };
  }();
  var getProdCmSaleVlBarYearAsync = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var data;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getProdCmSaleVlBar({
              date: params.value.date,
              type: 3
              // rangeType: -1,
              // rangeNum: 3
            });
          case 2:
            data = _context2.sent;
            aggregateSaleTrendYearData.value = data;
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function getProdCmSaleVlBarYearAsync() {
      return _ref2.apply(this, arguments);
    };
  }();
  var aggregateSaleCountData = ref([]);
  var getAggregateSaleCountAsync = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var _data$list;
      var data, countList, newCountList, currentCustomerId, tmpList, list, sum, newList;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return getAggregateSaleCount(params.value);
          case 2:
            data = _context3.sent;
            // 先添加合计数据
            countList = (_data$list = data.list) !== null && _data$list !== void 0 ? _data$list : [];
            countList.push({
              customer_id: 9999999999,
              customer: '额外添加的数据为了方便计算',
              car_cnt: '0',
              count: 0,
              customer_pay: '0',
              net_weight: '0',
              stone: 'fake料类名称'
            });
            newCountList = [];
            currentCustomerId = 0;
            tmpList = [];
            countList.forEach(function (item, index) {
              console.log(item, index, countList.length, 'caaaa');
              if (currentCustomerId !== 0 && item.customer_id !== currentCustomerId) {
                // if (countList.length - 1 === index) {
                //   tmpList.push(item);
                // }
                var moneyArr = tmpList.map(function (item) {
                  return parseFloat(item.customer_pay);
                });
                var weightArr = tmpList.map(function (item) {
                  return parseFloat(item.net_weight);
                });
                var carNumArr = tmpList.map(function (item) {
                  return parseFloat(item.car_cnt);
                });
                // 计算统计数据
                var tmpData = {
                  stone: '合计',
                  customer: tmpList[0].customer,
                  count: 0,
                  customer_id: tmpList[0].customer_id,
                  customer_pay: moneyArr.reduce(function (accumulator, currentValue) {
                    return accumulator + currentValue;
                  }, 0).toFixed(2),
                  net_weight: weightArr.reduce(function (accumulator, currentValue) {
                    return accumulator + currentValue;
                  }, 0).toFixed(2),
                  car_cnt: "".concat(carNumArr.reduce(function (accumulator, currentValue) {
                    return accumulator + currentValue;
                  }, 0))
                };
                if (countList.length - 1 === index) {
                  // newCountList.push(item);
                  newCountList.push(tmpData);
                } else {
                  newCountList.push(tmpData);
                  newCountList.push(item);
                }
                if (item.customer_id !== currentCustomerId) {
                  tmpList = [];
                }
              } else {
                newCountList.push(item);
              }
              tmpList.push(item);
              currentCustomerId = item.customer_id;
            });
            // 对数据进行处理，方便展示时合并单元格
            list = newCountList.reverse();
            sum = 1;
            currentCustomerId = 0;
            newList = [];
            list.forEach(function (item, index) {
              if (index !== 0) {
                if (item.customer_id !== currentCustomerId) {
                  sum = 1;
                } else {
                  sum++;
                }
              }
              item.count = sum;
              currentCustomerId = item.customer_id;
              newList.push(item);
            });
            aggregateSaleCountData.value = newList.reverse();
            console.log(aggregateSaleCountData.value, 'aggregateSaleCountData');
          case 16:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function getAggregateSaleCountAsync() {
      return _ref3.apply(this, arguments);
    };
  }();
  return [aggregateSaleTrendData, aggregateSaleTrendYearData, getProdCmSaleVlBarAsync, getProdCmSaleVlBarYearAsync, getAggregateSaleCountAsync, aggregateSaleCountData];
}